const PENDING_ORDER_KEY = "nextvial_stripe_pending_order";

export function savePendingOrder(payload) {
  try {
    sessionStorage.setItem(PENDING_ORDER_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn("Could not save pending order to sessionStorage", error);
  }
}

export function loadPendingOrder() {
  try {
    const raw = sessionStorage.getItem(PENDING_ORDER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.warn("Could not load pending order from sessionStorage", error);
    return null;
  }
}

export function clearPendingOrder() {
  try {
    sessionStorage.removeItem(PENDING_ORDER_KEY);
  } catch (error) {
    console.warn("Could not clear pending order from sessionStorage", error);
  }
}
